"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _EotcPriceChartComponent = _interopRequireDefault(require("./EotcPriceChartComponent"));
var _tickersActions = require("../../redux/actions/tickersActions");
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
var _productHelper = require("../../helpers/productHelper");
var _numberFormatter = require("../../helpers/numberFormatter");
var _config = _interopRequireDefault(require("../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DEFAULT_VALUE = '-';
var mapStateToProps = function mapStateToProps(state) {
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  var decimalPlaces = state.apexCore.product.decimalPlaces;
  var bidValue = state.eotcPrices.lastPrices[selectedInstrument.InstrumentId] ? state.eotcPrices.lastPrices[selectedInstrument.InstrumentId].Bid : 0;
  var askValue = state.eotcPrices.lastPrices[selectedInstrument.InstrumentId] ? state.eotcPrices.lastPrices[selectedInstrument.InstrumentId].Ask : 0;
  var theme = _config["default"].global.theme;
  var localConfig = JSON.parse(localStorage.getItem('apexTemplate')) || {};
  return {
    selectedInstrument: selectedInstrument,
    decimalPlaces: decimalPlaces,
    bidValue: !selectedInstrument.Product2Symbol ? DEFAULT_VALUE : (0, _productHelper.getBalanceWithProductSymbol)(selectedInstrument.Product2Symbol, (0, _numberFormatter.formatNumberToLocale)(bidValue, selectedInstrument.Product2Symbol)),
    askValue: !selectedInstrument.Product2Symbol ? DEFAULT_VALUE : (0, _productHelper.getBalanceWithProductSymbol)(selectedInstrument.Product2Symbol, (0, _numberFormatter.formatNumberToLocale)(askValue, selectedInstrument.Product2Symbol)),
    theme: localConfig.theme || theme,
    instrumentsArray: state.apexCore.instrument.instruments
  };
};
var mapDispatchToProps = {
  changeTickersInterval: _tickersActions.changeTickersInterval
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_EotcPriceChartComponent["default"]);